import { action, computed, observable } from 'mobx'

import { ISharedSitePermit, SitePermitStatus } from '~/client/graph'

import { getSharedProjectName } from '../../models/SharedInfo'

export default class SharedWorkflowStore {
  private sharedSitePermits = observable(new Map<string, ISharedSitePermit>())

  private get byId() {
    return this.sharedSitePermits
  }

  public getById = (id: string): ISharedSitePermit => {
    if (this.byId.has(id)) {
      return this.byId.get(id)
    }
  }

  @computed
  public get projectFromIdToCodeMap(): { [projectFromId: string]: string } {
    return this.list.reduce(
      (acc, sp) => {
        acc[sp.projectFromId] = getSharedProjectName(sp.projectUrl)
        return acc
      },
      {} as { [projectFromId: string]: string },
    )
  }

  @action.bound
  public clearList() {
    this.byId.clear()
  }

  @computed
  public get list(): ISharedSitePermit[] {
    return Array.from(this.byId.values()).filter(
      sp => sp.status !== SitePermitStatus.Deleted,
    )
  }

  @action.bound
  public receiveList(list: ISharedSitePermit[]) {
    this.byId.clear()

    list.forEach(dto => {
      this.byId.set(dto.id, dto)
    })
  }

  @action.bound
  public receiveOne(id: string, dto: ISharedSitePermit) {
    if (dto) {
      this.byId.set(id, dto)
    } else {
      this.byId.delete(id)
    }
  }
}
